const SET_PARAMS = "SET_PARAMS";
const SET_SELECTED_RESULT_INDEX = "SET_SELECTED_RESULT_INDEX";
const TOGGLE_SHOW_MORE_CANDIDATES = "TOGGLE_SHOW_MORE_CANDIDATES";
const SET_GEO_SELECTION = "SET_GEO_SELECTION";

const initialState = {
  params: {},
  selectedResultIndex: 0,
  showMoreCandidates: false,
  numOfCandidateByDefault: 5,
  geoSelection: null,
};

const mutations = {
  [SET_PARAMS](state, params) {
    state.params = params;
  },
  [SET_SELECTED_RESULT_INDEX](state, index) {
    state.selectedResultIndex = index;
  },
  [TOGGLE_SHOW_MORE_CANDIDATES](state, bool) {
    state.showMoreCandidates = bool;
  },
  [SET_GEO_SELECTION](state, geoSelection) {
    state.geoSelection = geoSelection;
  },
};

const actions = {
  setParams: ({ commit }, params) => {
    commit(SET_PARAMS, params);
  },
  setSelectedResultIndex: ({ commit }, index) => {
    commit(SET_SELECTED_RESULT_INDEX, index);
  },
  toggleShowMoreCandidates: ({ commit }, bool) => {
    commit(TOGGLE_SHOW_MORE_CANDIDATES, bool);
  },
  setGeoSelection: ({ commit }, geoSelection) => {
    commit(SET_GEO_SELECTION, geoSelection);
  },
};

const getters = {
  params(state) {
    return state.params;
  },
  selectedResultIndex(state) {
    return state.selectedResultIndex;
  },
  showMoreCandidates(state) {
    return state.showMoreCandidates;
  },
  numOfCandidateByDefault(state) {
    return state.numOfCandidateByDefault;
  },
  geoSelection(state) {
    return state.geoSelection;
  },
};

export default {
  namespaced: false,
  state: initialState,
  mutations,
  actions,
  getters,
};
